import React, { useState } from 'react';
import Style from './FinanciamentoDePesados25Blog.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import CustomEmblaCarouselHome24 from '../CustomEmblaCarouselHome24';

function FinanciamentoDePesados25Blog() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);
  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section id="boleto-conteudos">
        <ContainerHome24>
          <h2 className="boleto-conteudos-titulo">Consulte nossos conteúdos</h2>
          <div className="is-mobi">
            {/* <h2 className="boleto-conteudos-titulo">Consulte nossos conteúdos</h2> */}
            <CustomEmblaCarouselHome24
              enableBullets
              bulletCount={3}
              enableMobileArrows
              enablePrevArrow
            >
              {({ className }) => (
                <>
                  <div className={`boleto-conteudos-slide ${className}`}>
                    <a href="blog/financiamento-de-pesados.html" className="boleto-conteudos-card">
                      <picture>
                        <source
                          type="image/webp"
                          srcSet="static/amp/blog/post-4/pesados-novidades.webp"
                        />
                        <source
                          type="image/jpg"
                          srcSet="static/amp/blog/post-4/pesados-novidades.jpg"
                        />
                        <img
                          src="static/amp/blog/post-4/pesados-novidades.jpg"
                          alt="Frota de caminhões brancos"
                        />
                      </picture>

                      <div className="boleto-conteudos-card-textos">
                        <h3 className="boleto-conteudos-slide-titulo">Financiamento de Pesados</h3>
                        <p className="boleto-conteudos-slide-link">Saiba mais</p>
                      </div>
                    </a>
                  </div>
                  <div className={`boleto-conteudos-slide ${className}`}>
                    <a href="blog/como-financiar-um-veiculo.html" className="boleto-conteudos-card">
                      <picture>
                        <source type="image/webp" srcSet="static/amp/blog/post-3/banner.webp" />
                        <source type="image/jpg" srcSet="static/amp/blog/post-3/banner.jpg" />
                        <img
                          src="static/amp/blog/post-3/banner.jpg"
                          alt="Homen feliz ao comprar seu novo carro"
                        />
                      </picture>

                      <div className="boleto-conteudos-card-textos">
                        <h3 className="boleto-conteudos-slide-titulo">
                          Como financiar um veículo?
                        </h3>
                        <p className="boleto-conteudos-slide-link">Saiba mais</p>
                      </div>
                    </a>
                  </div>
                  <div className={`boleto-conteudos-slide ${className}`}>
                    <a href="blog/seguro-auto.html" className="boleto-conteudos-card">
                      <picture>
                        <source type="image/webp" srcSet="static/amp/blog/post-14/capa.webp" />
                        <source type="image/png" srcSet="static/amp/blog/post-14/capa.png" />
                        <img
                          src="static/amp/blog/post-14/capa.png"
                          alt="Casal de homem e mulher sentados no porta malas de um veiculo prata, segurando uma criança no colo. O veiculo está parado em uma estrada de terra com gramado verde em volta."
                        />
                      </picture>

                      <div className="boleto-conteudos-card-textos">
                        <h3 className="boleto-conteudos-slide-titulo">
                          Proteja seu veículo com o seguro auto
                        </h3>
                        <p className="boleto-conteudos-slide-link">Saiba mais</p>
                      </div>
                    </a>
                  </div>
                </>
              )}
            </CustomEmblaCarouselHome24>
          </div>

          <div className="is-desk">
            {/* <h2 className="boleto-conteudos-titulo">Consulte nossos conteúdos</h2> */}
            <div className="cards-desk">
              <a href="blog/financiamento-de-pesados.html" className="boleto-conteudos-card">
                <picture>
                  <source
                    type="image/webp"
                    srcSet="static/amp/blog/post-4/pesados-novidades.webp"
                  />
                  <source type="image/jpg" srcSet="static/amp/blog/post-4/pesados-novidades.jpg" />
                  <img
                    src="static/amp/blog/post-4/pesados-novidades.jpg"
                    alt="Frota de caminhões brancos"
                  />
                </picture>
                <div className="boleto-conteudos-card-textos">
                  <h3 className="boleto-conteudos-slide-titulo">Financiamento de Pesados</h3>
                  <p className="boleto-conteudos-slide-link">Saiba mais</p>
                </div>
              </a>
              <a href="blog/como-financiar-um-veiculo.html" className="boleto-conteudos-card">
                <picture>
                  <source type="image/webp" srcSet="static/amp/blog/post-3/banner.webp" />
                  <source type="image/jpg" srcSet="static/amp/blog/post-3/banner.jpg" />
                  <img
                    src="static/amp/blog/post-3/banner.jpg"
                    alt="Homen feliz ao comprar seu novo carro"
                  />
                </picture>
                <div className="boleto-conteudos-card-textos">
                  <h3 className="boleto-conteudos-slide-titulo">Como financiar um veículo?</h3>
                  <p className="boleto-conteudos-slide-link">Saiba mais</p>
                </div>
              </a>
              <a href="blog/seguro-auto.html" className="boleto-conteudos-card">
                <picture>
                  <source type="image/webp" srcSet="static/amp/blog/post-14/capa.webp" />
                  <source type="image/png" srcSet="static/amp/blog/post-14/capa.png" />
                  <img
                    src="static/amp/blog/post-14/capa.png"
                    alt="Casal de homem e mulher sentados no porta malas de um veiculo prata, segurando uma criança no colo. O veiculo está parado em uma estrada de terra com gramado verde em volta."
                  />
                </picture>
                <div className="boleto-conteudos-card-textos">
                  <h3 className="boleto-conteudos-slide-titulo">
                    Proteja seu veículo com o seguro auto
                  </h3>
                  <p className="boleto-conteudos-slide-link">Saiba mais</p>
                </div>
              </a>
            </div>
          </div>
        </ContainerHome24>
      </section>
      <style jsx>{Style}</style>
    </>
  );
}

export default FinanciamentoDePesados25Blog;
